import { useState } from "react";
import usePartyStore from "../../stores/party.js";
import PartyResults from "./partyResults.js";
import { log } from "@tumbodash/browserPackages";
import Preview from "./Preview/index.js";
import Lobby from "./Lobby/index.js";
import Stage from "./Stage/index.js";
import GameResults from "./gameResults.js";

function Party() {
	log.fx("(view:party:main)");
	const party = usePartyStore.getState().party!;
	const [viewResults, setViewResults] = useState(true);

	let view = <>Loading.....</>;
	if (party.phase === 3) view = <PartyResults />;
	else if (party.phase === 0) view = <Lobby />;
	else if (party.phase === 1 && party.activeRound >= 2 && viewResults)
		view = <GameResults viewResults={viewResults} setViewResults={setViewResults} />;
	else if (party.phase === 1 || party.phase === 3) view = <Preview />;
	else if (party.phase === 2) view = <Stage setViewResults={setViewResults} />;

	return <>{view}</>;
}

export default Party;
